import { Injectable, Inject } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs/Observable';
import { DisturbanceSubscription, NotificationSetting, UserNotificationPreferences, AuthService } from '../..';
import { of } from 'rxjs';
import { TranslateService } from '@ngx-translate/core';

@Injectable({
    providedIn: 'root'
})
export class NotificationSettingsService {
    private newAFCConfigurationSettings: NotificationSetting;
    constructor(
        private http: HttpClient,
        @Inject('ENV') public env: any,
        private ridangoAuth: AuthService,
        private translateService: TranslateService
    ) {}

    getNotificationSettings(): Observable<NotificationSetting> {
        const url = `${this.env.CORE_API_URL}/customer/v3/region/${this.env.REGION_ID}/customer/channel`;
        return this.http.get<NotificationSetting>(url);
    }

    updateNotificationSettings(payload: NotificationSetting): Observable<any> {
        if (this.env.IS_NEW_AFC) {
            this.newAFCConfigurationSettings = payload;
            return of(this.newAFCConfigurationSettings);
        }

        const url = `${this.env.CORE_API_URL}/customer/v3/region/${this.env.REGION_ID}/customer/channel`;
        return this.http.post(url, payload);
    }

    getNotificationPreferences(): Observable<UserNotificationPreferences> {
        const url = `${this.env.WMB.WMB_PUBLIC_API}/v1/notification-preferences`;
        return this.http.get<UserNotificationPreferences>(url);
    }

    updateNotificationPreferences(preferences: UserNotificationPreferences): Observable<void> {
        const url = `${this.env.WMB.WMB_PUBLIC_API}/v1/notification-preferences`;
        return this.http.put<void>(url, preferences);
    }

    getDisturbanceSubscriptions(): Observable<DisturbanceSubscription[]> {
        const url = `${this.env.WMB.WMB_PUBLIC_API}/v1/disturbance/subscription`;
        return this.http.get<DisturbanceSubscription[]>(url);
    }

    addDisturbanceSubscription(subscription: Partial<DisturbanceSubscription>): Observable<DisturbanceSubscription> {
        const token = this.ridangoAuth.getLocalAccessToken();
        const lang = this.translateService.currentLang;

        const headers = new HttpHeaders().set('Authorization', `Bearer ${token}`).set('Content-Language', lang);
        const options = {
            headers: headers
        };
        const url = `${this.env.WMB.WMB_PUBLIC_API}/v1/disturbance/subscription`;
        return this.http.post<DisturbanceSubscription>(url, subscription, options);
    }

    updateDisturbanceSubscription(
        id: string,
        subscription: Partial<DisturbanceSubscription>
    ): Observable<DisturbanceSubscription> {
        const url = `${this.env.WMB.WMB_PUBLIC_API}/v1/disturbance/subscription/${id}`;
        return this.http.put<DisturbanceSubscription>(url, subscription);
    }

    deleteDisturbanceSubscription(id: string): Observable<any> {
        const url = `${this.env.WMB.WMB_PUBLIC_API}/v1/disturbance/subscription/${id}`;
        return this.http.delete(url);
    }
}
